import styled from 'styled-components';

// Calming color palette - same as other forms for consistency
const colors = {
  primary: '#4A90E2',      // Calming blue
  secondary: '#7FB3D5',    // Soft blue
  accent: '#D4E6F1',       // Very light blue
  text: '#2C3E50',         // Dark blue-gray
  background: '#F5F9FC',   // Off-white with blue hint
  success: '#5cb85c',      // Gentle green
  error: '#d9534f',        // Soft red
  warning: '#f0ad4e',      // Warm amber
  white: '#FFFFFF',
  gray: '#ECEFF1'
};

export const FormContainer = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 24px 24px 24px;
  background: ${colors.white};
  border-radius: 12px;
  
  @media (max-width: 768px) {
    padding: 24px 16px 16px 16px;
    border-radius: 8px;
    margin-top: 17px;
    margin-bottom: 8px;
  }
`;

export const FormTitle = styled.h2`
  color: ${colors.text};
  margin-bottom: 0;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.5px;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 28px;
    letter-spacing: -0.3px;
    margin-bottom: 14px;
  }
`;

export const FormSection = styled.div`
  background: ${colors.background};
  border-radius: 12px;
  padding: 24px 28px 32px 28px;
  margin-bottom: 24px;
  border: 2px solid ${colors.accent};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 40px; /* Extra padding for last section */
  }
  
  /* Ensure proper spacing for form items within sections */
  .ant-form-item {
    margin-bottom: 24px !important;
    
    &:last-child {
      margin-bottom: 16px !important; /* More space for error messages */
    }
  }
  
  /* Style error messages consistently */
  .ant-form-item-explain-error {
    color: ${colors.error} !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 1.4 !important;
    margin-top: 6px !important;
    margin-bottom: 4px !important;
  }
  
  @media (max-width: 768px) {
    padding: 20px 22px 28px 22px;
    margin-bottom: 20px;
    border-width: 1px;
    border-radius: 10px;
    
    &:last-child {
      padding-bottom: 36px; /* Extra padding for last section on mobile */
    }
    
    .ant-form-item {
      margin-bottom: 20px !important;
      
      &:last-child {
        margin-bottom: 14px !important;
      }
    }
  }
`;

export const LocationTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${colors.primary};
  line-height: 1.3;
  
  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 14px;
  }
`;

export const FormRow = styled.div`
  margin-bottom: 32px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  /* Add extra space for form items to prevent error message overlap */
  .ant-form-item {
    margin-bottom: 24px !important;
    
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
  
  /* Ensure error messages have proper spacing */
  .ant-form-item-explain-error {
    margin-top: 6px !important;
    margin-bottom: 8px !important;
    color: #d9534f !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 28px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .ant-form-item {
      margin-bottom: 20px !important;
    }
  }
`;

export const FormField = styled.div`
  width: 100%;
`;

export const FieldLabel = styled.span`
  font-weight: 600;
  color: ${colors.text};
  font-size: 16px;
  line-height: 1.4;
  display: block;
  margin-bottom: 8px;
  
  ${props => props.required && `
    &::after {
      content: ' *';
      color: ${colors.error};
    }
  `}
`;

export const RequiredFieldNotice = styled.div`
  color: ${colors.error};
  font-size: 14px;
  margin-top: -20px;
  margin-bottom: 16px;
  line-height: 1.4;
  font-weight: 400;
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    margin-top: 32px;
    margin-bottom: 20px;
  }
`;

export const ComplianceNotice = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  
  img {
    max-width: 150px;
    height: auto;
  }
`;